import React, { useState, useEffect } from "react";
import { Row, Col, Card, Breadcrumb, Table, Form } from 'react-bootstrap';
import { Button } from 'primereact/button';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { Link } from "react-router-dom";
import '../../assets/css/client.css';
import { Avatar } from 'primereact/avatar';
import noUserImage from '../../assets/images/client-default.png'
import { Dialog } from 'primereact/dialog';
import Add_client from '../../components/Add_client';
import GifLoder from '../../components/GifLoder';



const Client_list = () => {
    const { accessToken } = useAuth();
    const [clients, setClients] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(10); // Default limit
    const [billingName, setBillingName] = useState(''); // Search term
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [debounceTimeout, setDebounceTimeout] = useState(null);

    // Fetch client data
    const fetchClients = async () => {
        setLoading(true);
        setClients([]); // Clear old data before fetching new
        try {
            const response = await axios.get(`${config.apiBASEURL}/ClientRoutes/clients`, {
                params: {
                    limit,
                    billingName,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setClients(response.data.clients);
            setTotalCount(response.data.totalCount);

            // Simulate a 3-second loading delay
            setTimeout(() => {
                setLoading(false);
            }, 1200); // 3000ms delay
        } catch (error) {
            console.error('Error fetching clients:', error);
            setLoading(false); // Ensure loading is stopped even if there's an error
        }
    };


    // Debounce handler for the search input
    const handleSearchChange = (e) => {
        setBillingName(e.target.value);

        // Clear the previous timeout to prevent multiple calls
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }

        // Set a new timeout to call the fetchClients function after 500ms of inactivity
        const timeout = setTimeout(() => {
            fetchClients();
        }, 1500);

        setDebounceTimeout(timeout);
    };

    useEffect(() => {
        fetchClients(); // Initial fetch when the page loads
    }, [limit, accessToken]);

    // Centralized success handler
    const fetchClientsdata = async () => {
        fetchClients(); // Refresh the client data
        setVisible(false); // Hide the modal or dialog
    };

    return (
        <>
            {loading ? (
                <div className="loderDiv">
                    <GifLoder />
                </div>
            ) : (
                <Row className='body_content'>
                    <Row className='mx-0'>
                        <Col md={12} lg={12} className='mb-4 d-flex justify-content-between align-items-center'>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Clients</Breadcrumb.Item>
                            </Breadcrumb>
                            <Button
                                label="Add Client"
                                className="py-2 border-0"
                                severity="help"
                                icon="pi pi-plus"
                                onClick={() => setVisible(true)}
                            />
                        </Col>
                        <Col lg={12} className="p-0 resp_report">
                            <Card>
                                <Card.Header className="border-0">
                                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                                        <div>
                                            <h6 className="mb-0">Total Clients: {totalCount}</h6>
                                        </div>
                                        <div className="d-flex flex-wrap justify-content-end align-items-center mt-3 mt-lg-0">
                                            <IconField iconPosition="left" style={{ width: '200px' }} className="me-1 me-lg-2 ">
                                                <InputIcon className="pi pi-search"></InputIcon>
                                                <InputText
                                                    placeholder="Search by company."
                                                    className="ps-5"
                                                    value={billingName}
                                                    onChange={handleSearchChange}
                                                />
                                            </IconField>
                                            <Form.Select
                                                aria-label="Default select example"
                                                style={{ width: '80px' }}
                                                value={limit}
                                                onChange={(e) => setLimit(parseInt(e.target.value, 10))}
                                            >
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={30}>30</option>
                                                <option value={100}>100</option>
                                                <option value={250}>250</option>
                                                <option value={500}>500</option>
                                            </Form.Select>
                                        </div>
                                    </div>
                                </Card.Header>
                                <Card.Body className="pt-0">
                                    <Table size="sm" hover className="clTable">
                                        <thead className="table-primary sticky-top" style={{ top: '-36px' }}>
                                            <tr>
                                                <th>Company Name</th>
                                                <th>POC</th>
                                                <th>Bill Name</th>
                                                <th>Date</th>
                                                <th style={{ width: '60px' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {clients.map((client) => (
                                                <tr key={client.Client_id}>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <Avatar image={noUserImage} shape="circle" size="small" />
                                                            <span className="ms-2">
                                                                <b>{client.Billing_name}</b>
                                                                <small className="d-block mt-1"><i className="pi pi-envelope me-1 text-warning"></i> {client.email} </small>
                                                                <small className="d-block"><i className="pi pi-phone me-1 text-success"></i> {client.ClientDetails.phone}</small>
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>{client.ClientDetails?.poc || 'N/A'}</td>
                                                    <td>{client.ClientDetails.bill_name}</td>
                                                    <td>{new Date(client.ClientDetails.createdAt).toLocaleDateString('en-GB')}</td>
                                                    <td>
                                                        <Link to={`/Graphe/dashboard/view_client/${client.Client_id}`}>
                                                            <Button
                                                                label="View"
                                                                className="py-1 px-2 border-0"
                                                                severity="primary"
                                                                text
                                                            />
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>

                </Row>
            )}
            <Dialog
                header="Client Add"
                visible={visible}
                style={{ width: '40vw' }}
                onHide={() => setVisible(false)}
            >
                <Add_client onSuccess={fetchClientsdata} />
            </Dialog>

            {/* <div className="loderDiv">
                 <GifLoder/>
             </div> */}

        </>
    );
};

export default Client_list;

